/* eslint-disable import/no-anonymous-default-export */
export default {
    auth: {
        login: "تسجيل الدخول"
    }
    
}